import { List, NumberField, TextField, TextInput, SelectInput, useDataProvider, DateInput } from 'react-admin';
import Datagrid from '../Commons/Datagrid';
import PostPagination from '../Commons/PostPagination';
import ListActions from '../Commons/ListActions';
import { useMediaQuery, createTheme } from '@mui/material';
import BreadCrumbCustom from '../Commons/BreadCrum';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import historyTracker from '../Commons/historyTracker';
import AuthNotification from '../Commons/AuthNotification';
import show from './DownPaymentsPortfolioShow';
import FilterSidebar from '../Commons/FilterSidebar';
import { StyleTheme, Style } from '../Commons/Styles.jsx';
import { createStyles, makeStyles } from '@mui/styles';
import InternalMenu from '../Commons/InternalMenu';
import credits from '../Commons/Icons/creditos.svg';
import fail from '../Commons/Icons/faild.svg';
import pay from '../Commons/Icons/pay.svg';
import book from '../Commons/Icons/book.svg';
import stats from '../Commons/Icons/stats.svg';
import CircularProgress from '@mui/material/CircularProgress';

import { hasPermissions } from '../Commons/CompanyAuth';

const useStyles = makeStyles(() => createStyles(StyleTheme));

const RequestList = (props) => {
  const classes = useStyles();
  const theme = createTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const location = useLocation();
  const [advisors, setAdvisors] = useState([]);
  const [states, setStates] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const [products, setProducts] = useState([]);
  const [openAuth, setOpenAuth] = useState(false);
  const [auth, setAuth] = useState(false);
  // Mientras esto es true se muestra el spinner de carga inicial (ver el bloque
  // "initialLoading" en el return): esta pantalla necesita traer los permisos y los
  // catalogos de filtro antes de poder mostrar el listado, y sin este estado la ventana
  // se veia en blanco (solo el breadcrumb) durante esa espera.
  const [initialLoading, setInitialLoading] = useState(true);
  const dataProvider = useDataProvider();

  useEffect(() => {
    (async () => {
      try {
        let data = await dataProvider.getMany('advisors/downpayments/general', { ids: [] });
        var advisors = data.data.map(item => (
          {
            id: item.id,
            name: item.name
          }
        ));

        setAdvisors(advisors);

        data = await dataProvider.getMany('agencies/downpayments/general', { ids: [] });
        var agencies = data.data.map(item => (
          {
            id: item.id,
            name: item.name
          }
        ));

        setAgencies(agencies);

        data = await dataProvider.getMany('state/downpayments/general', { ids: [] });
        var states = data.data.map(item => (
          {
            id: item.id,
            name: item.name
          }
        ));

        setStates(states);

        data = await dataProvider.getMany('products/downpayments/', { ids: [] });
        var products = data.data.map(item => (
          {
            id: item.id,
            name: item.name
          }
        ));

        setProducts(products);

        historyTracker.addPath(location.pathname, 'Enganches Saldos Cartera', 2);

        const authdata = { data: hasPermissions('ReportDownPaymentsPortfolio', 'read') };
        if (authdata.data.length > 0) {
          setAuth(authdata.data[0]);
          setOpenAuth(!authdata.data[0]);
        } else {
          setAuth(false);
          setOpenAuth(true)
        }
      }
      catch {
      }
      finally {
        setInitialLoading(false);
      }
    })();
  }, [dataProvider, location.pathname]);

  const handleRedirectFail = () => {
    navigate(`/reports/downpayment/fail`);
  };

  const handleRedirectPortfolio = () => {
    navigate(`/reports/downpayment/portfolio`);
  };

  const handleRedirectPayments = () => {
    navigate(`/reports/downpayment/payments`);
  };

  const handleRedirectAnalysis = () => {
    navigate(`/reports/downpayment/analysis`);
  };

  const [openDownPayments, setOpeDownPayments] = useState(true);

  const handleClickOpenDownPayments = () => {
    setOpeDownPayments(!openDownPayments);
  };

  const menus = [{
    icon: <img src={credits} alt="logo" style={Style.MenuLogo} />, name: 'Enganches',
    open: openDownPayments,
    openAction: handleClickOpenDownPayments,
    actions: [
      { icon: <img src={fail} alt="logo" style={Style.MenuLogo} />, name: 'Rescindidos/Rechazados', onClick: handleRedirectFail },
      { icon: <img src={book} alt="logo" style={Style.MenuLogo} />, name: 'Saldos Cartera', onClick: handleRedirectPortfolio },
      { icon: <img src={pay} alt="logo" style={Style.MenuLogo} />, name: 'Pagos', onClick: handleRedirectPayments },
      { icon: <img src={stats} alt="logo" style={Style.MenuLogo} />, name: 'Análisis Completo', onClick: handleRedirectAnalysis },
    ]
  }]

  let pagination = <PostPagination menu={<InternalMenu menus={menus} />} />;

  const PostFilter = [
    <TextInput InputProps={{ disableUnderline: true }} label={<span>{"Imuebles"}</span>} source="realStates" alwaysOn />,
    <TextInput InputProps={{ disableUnderline: true }} label={<span>{"Clientes"}</span>} source="customer" alwaysOn />,
    <DateInput InputProps={{ disableUnderline: true }} label={<span>{"Fecha"}</span>} source="date" alwaysOn />,
    <SelectInput InputProps={{ disableUnderline: true }} label={<span>{"Estado"}</span>} source="state" choices={states} alwaysOn />,
    <SelectInput InputProps={{ disableUnderline: true }} label={<span>{"Asesor"}</span>} source="advisor" choices={advisors} alwaysOn />,
    <SelectInput InputProps={{ disableUnderline: true }} label={<span>{"Agencia"}</span>} source="agency" choices={agencies} alwaysOn />,
    <SelectInput InputProps={{ disableUnderline: true }} label={<span>{"Producto"}</span>} source="product" choices={products} alwaysOn />
  ]

  return (
    <div class="container">
      <BreadCrumbCustom history={historyTracker.getHistory()} />
      {initialLoading ? (
        // Spinner de carga inicial: reutiliza la misma clase "Loading" (index.css) y el
        // mismo CircularProgress que ya se usa en otras pantallas para el guardado, pero
        // aqui cubre la espera de los permisos y catalogos de filtro, que antes dejaba la
        // pantalla en blanco.
        <div class="Loading" style={{ display: 'block' }}>
          <CircularProgress size="15rem" />
        </div>
      ) : auth ? (
        <div class="row">
          <div class="col-12">
            {isSmall ? (
              <List empty={false} {...props} actions={<ListActions />} bulkActionButtons={false} pagination={pagination}>
                <Datagrid {...props} expand={show} rowClick="expand">
                </Datagrid>
              </List>
            ) : (
              <List empty={false} perPage={10} {...props} aside={<FilterSidebar {...props} filters={PostFilter} />} actions={<ListActions download />} bulkActionButtons={false} pagination={pagination}>
                <Datagrid {...props} expand={show} rowClick="expand" style={Style.DataGrid}>
                  <TextField source="realStates" style={Style.fieldList} label="Inmuebles" cellClassName={classes.fields} />
                  <TextField source="customer" style={Style.fieldList} label="Cliente" cellClassName={classes.fields} styleheader={{ ...Style.DataGrid, width: "20em" }} />
                  <TextField source="state" style={Style.fieldList} label="Estado" cellClassName={classes.fields} />
                  <NumberField source="calculatedCommission" style={Style.fieldList} label="Comisión Calculada" sortable={true} cellClassName={classes.fields} options={{ style: 'currency', currency: 'GTQ' }} />
                  <NumberField source="downPaymentPaid" style={Style.fieldList} label="Enganche Pagado" sortable={true} cellClassName={classes.fields} options={{ style: 'currency', currency: 'GTQ' }} />
                </Datagrid>
              </List>
            )}
          </div>
        </div>) : (<AuthNotification openerror={openAuth} severity={'error'} message={'No posee los permisos para poder interactuar con esta vista'} />)}
    </div>
  )
};

export default RequestList;